import {AfterViewChecked, Directive, ElementRef, inject, input} from '@angular/core';
import {AbstractControl} from '@angular/forms';

@Directive({
  selector: '[appFormValidationClass]',
  standalone: true
})
export class FormValidationClassDirective implements AfterViewChecked {
  private el = inject(ElementRef);


  readonly formField = input<AbstractControl | null>();
  readonly customValidation = input<boolean>();
  readonly onlyShowError = input<boolean>(false);
  readonly validationDisabled = input<boolean>(false);

  ngAfterViewChecked() {
    if (this.validationDisabled()) {
      return;
    }
    let valid;
    let touched;
    const formField = this.formField();
    if (!formField) {
      touched = true;
    } else {
      touched = formField.touched;
    }

    if (formField?.disabled) {
      this.el.nativeElement.classList.remove('is-invalid');
      this.el.nativeElement.classList.remove('is-valid');
      return;
    }

    if (this.customValidation() !== undefined) {
      valid = this.customValidation();
    }

    const customValidation = this.customValidation();
    if (customValidation !== undefined) {
      valid = customValidation;
    } else {
      valid = !formField?.invalid;
    }

    if (!valid) {
      if (touched) {
        this.el.nativeElement.classList.add('is-invalid');
        this.el.nativeElement.classList.remove('is-valid');
      }
      if (!touched) {
        this.el.nativeElement.classList.remove('is-invalid');
        this.el.nativeElement.classList.remove('is-valid');
      }
    }

    if (valid) {
      this.el.nativeElement.classList.remove('is-invalid');
      if (!this.onlyShowError()) {
        this.el.nativeElement.classList.add('is-valid');
      }
    }
  }

}
